import { IColumnProps } from "devextreme-react/data-grid";

import { auditFieldColumns } from "../../../model/metaData";

export const dummyJournalEntryRow = {
  accountName: "string",
  debitCredit: "Debit",
  amountFormula: "string",
  conditionFormula: "string",
};

export const dummyArmMappingDimensionRow = {
  mappingDimensionName: "string",
  defaultForAllExceptExcluded: true,
  isExcluding: true,
  values: [],
};

export const dummyArmMappingDimensionValueRow = {
  value: "string",
};

export const dummyJournalEntryTypeMappingRow = {
  journalEntryTypes : [],
  mappingDimensions : [],
  mappingName: "string",
  description: "string",
  active: true,
};

export const dummyAffixMappingRow = {
  mappingName: "string",
  description: "string",
  mappingDimensions : [],
  affix: "string",
  affixFormula: "string",
  isPrefix: true,
  active: true,
};

export const dummyGroupRuleMappingRow = {
  mappingName: "string",
  description: "string",
  mappingDimensions : [],
  perTransaction: true,
  combineCreditDebitForSameAccount: true,
  groupByMappingDimensions: [],
  active: true,
};

export const dummyAccountingDateRuleMappingRow = {
  mappingName: "string",
  description: "string",
  mappingDimensions : [],
  accountingDateFormula: "string",
  accountingPeriodFormula: "string",
  fiscalYearFormula: "string",
  active: true,
};

export const dummyReferenceMappingRow = {
  mappingName: "string",
  description: "string",
  mappingDimensions : [],
  numberReferenceFormula: "string",
  stringReferenceFormula: "string",
  journalEntryTypeOption: 3,
  active: true,
};

export const armMappingDimensionColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingDimensionName",
      {
        dataField: "mappingDimensionName",
        caption: "Mapping Dimension",
      },
    ],
    [
      "isExcluding",
      {
        dataField: "isExcluding",
        caption: "Is Excluding?",
      },
    ],
    [
      "defaultForAllExceptExcluded",
      {
        dataField: "defaultForAllExceptExcluded",
        caption: "Default For All Except Excluded",
      },
    ],
    [
      "values",
      {
        dataField: "values",
        caption: "Values",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
  ]),
);

export const armMappingDimensionValueColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "value",
      {
        dataField: "value",
        caption: "Value",
      },
    ],
  ]),
);

export const journalEntryTypeMappingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingName",
      {
        dataField: "mappingName",
        caption: "Mapping Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "mappingDimensions",
      {
        dataField: "mappingDimensions",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    [
      "journalEntryTypes",
      {
        dataField: "journalEntryTypes",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const affixMappingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingName",
      {
        dataField: "mappingName",
        caption: "Mapping Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "mappingDimensions",
      {
        dataField: "mappingDimensions",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    [
      "affix",
      {
        dataField: "affix",
        caption: "Affix",
      },
    ],
    [
      "affixFormula",
      {
        dataField: "affixFormula",
        caption: "Affix Formula",
      },
    ],
    [
      "isPrefix",
      {
        dataField: "isPrefix",
        caption: "Prefix?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const groupRuleMappingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingName",
      {
        dataField: "mappingName",
        caption: "Mapping Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "mappingDimensions",
      {
        dataField: "mappingDimensions",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    [
      "perTransaction",
      {
        dataField: "perTransaction",
        caption: "Per Transaction?",
      },
    ],
    [
      "combineCreditDebitForSameAccount",
      {
        dataField: "combineCreditDebitForSameAccount",
        caption: "Combine Credit/Debit?",
      },
    ],
    [
      "groupByMappingDimensions",
      {
        dataField: "Group By",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const accountingDateRuleMappingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingName",
      {
        dataField: "mappingName",
        caption: "Mapping Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "mappingDimensions",
      {
        dataField: "mappingDimensions",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    [
      "accountingDateFormula",
      {
        dataField: "accountingDateFormula",
        caption: "Accounting Date Formula",
      },
    ],
    [
      "accountingPeriodFormula",
      {
        dataField: "accountingPeriodFormula",
        caption: "Accounting Period Formula",
      },
    ],
    [
      "fiscalYearFormula",
      {
        dataField: "fiscalYearFormula",
        caption: "Fiscal Year Formula",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const referenceMappingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingName",
      {
        dataField: "mappingName",
        caption: "Mapping Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "mappingDimensions",
      {
        dataField: "mappingDimensions",
        customizeText: function (e: any) {
          return "...";
        },
      },
    ],
    [
      "numberReferenceFormula",
      {
        dataField: "numberReferenceFormula",
        caption: "Number Reference Formula",
      },
    ],
    [
      "stringReferenceFormula",
      {
        dataField: "stringReferenceFormula",
        caption: "String Reference Formula",
      },
    ],
    [
      "journalEntryTypeOption",
      {
        dataField: "journalEntryTypeOption",
        caption: "Journal Entry Type",
        customizeText: function (e: any) {
          switch (e.value) {
            case 1:
              return "Debit";
            case 2:
              return "Credit";
            case 3:
              return "Both";
            default:
              return "";
          }
        },
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);
